import React, { useEffect } from "react";
import { Button, Input, Space, Col, Row, Spin, Alert } from "antd";

import { useContext } from "react";
import { UserContext } from "../../../context/UserContext";
import StatCard from "../../../components/cards/StatCard";
import ChartCard from "../../../components/cards/ChartCard";
import ListCard from "../../../components/cards/ListCard";
import ApplicationsTable from "../applicants/components/ApplicationsTable";
import useLandlordApplications from "../applicants/hooks/useApplications";

const DashPage = () => {
  useEffect(() => {}, []);

  const { user } = useContext(UserContext);
  const {
    rows: applications,
    loading,
    error,
  } = useLandlordApplications(user?.uid);

  const cashflowData = [
    { month: "Jan", income: 4000, expense: 2400 },
    { month: "Feb", income: 3000, expense: 1398 },
    { month: "Mar", income: 2000, expense: 9800 },
    { month: "Apr", income: 2780, expense: 3908 },
    { month: "May", income: 1890, expense: 4800 },
    { month: "Jun", income: 2390, expense: 3800 },
  ];

  const tenantItems = [
    {
      address: "Unit 104",
      time: "2h ago",
      status: "In Progress",
      color: "gold",
    },
    {
      address: "Unit 472",
      time: "3h ago",
      status: "Completed",
      color: "green",
    },
    {
      address: "Unit 903",
      time: "1h ago",
      status: "Overdue",
      color: "red",
    },
  ];

  return (
    <Space
      direction="vertical"
      size={32}
      style={{ width: "100%", paddingTop: "0px" }}
    >
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: 600,
              marginBottom: "10px",
            }}
          >
            Welcome {user?.firstname || ""} {user?.lastname || ""}!
          </h2>
          <div style={{ color: "#888" }}>
            This is what we’ve got for you today
          </div>
        </Col>

        {/* <Col>
          <Space>
            <Input placeholder="Property" style={{ width: 150 }} />
            <Input placeholder="Portfolio" style={{ width: 150 }} />
            <Input placeholder="Filter" style={{ width: 120 }} />
            <Button>Customize</Button>
          </Space>
        </Col> */}
      </Row>

      <Row gutter={[24, 24]} align="stretch">
        <Col xs={24} sm={12} md={6}>
          <StatCard
            title="Rent Received"
            amount="$6,876.00"
            progress={70}
            status="8 payments completed"
            color="#52c41a"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard
            title="Unpaid Expenses"
            amount="$140.87"
            status="2 unpaid"
            color="#faad14"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard
            title="Overdue Rent"
            amount="$2,300.00"
            status="5 overdue"
            color="#ff4d4f"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard
            title="Upcoming Expenses"
            amount="$2,200.00"
            status="2 this month"
            color="#1890ff"
          />
        </Col>
      </Row>

      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          <ChartCard
            title="Cashflow"
            data={cashflowData}
            colors={{ income: "#1890ff", expense: "#f5222d" }}
          />
        </Col>
        <Col xs={24} md={12}>
          <ListCard title="Maintenance Requests" items={tenantItems} />
        </Col>
      </Row>

      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          {loading ? (
            <Spin tip="Loading applications..." />
          ) : error ? (
            <Alert
              type="error"
              message="Failed to load applications"
              description={error.message}
            />
          ) : (
            <ApplicationsTable data={applications} hideExtraColumns={true} />
          )}
        </Col>
        <Col xs={24} sm={12} md={12}>
          <ListCard title="Lease Renwals" items={tenantItems} />
        </Col>
      </Row>
    </Space>
  );
};

export default DashPage;
